import { Box, Typography } from "@mui/material";

export default function Item({ label, text, unit }) {
  return (
    <Box>
      <Typography component="p" className="item-text label color-blue-dark">
        {label}
      </Typography>
      <Typography component="p" mt="8px" className="item-text color-gray">
        {text} {unit}
      </Typography>
    </Box>
  );
}
